<template>
  <v-container fluid>
    <v-card class="pa-6">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Invoice</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6">
          <!-- to="/so-for-invoice" -->
          <!-- <v-btn
            to="/miscellaneous-list"
            color="#0A7EA5"
            rounded
            dark
            class="mb-2 mr-2"
          >
            <span>Add Miscellaneous List</span>
          </v-btn> -->
          <v-btn @click="getPrintDialog" color="#0A7EA5" rounded dark class="mb-2">
            <span>Add</span>
            <v-icon small center>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">
          <v-row>
            <v-col cols="12" md="7">
              <v-text-field v-model="search" append-icon="mdi-magnify" :label="setlanguage.labelsearch" single-line
                hide-details outlined dense @keyup.enter="findAllByAPISearch"></v-text-field>
              <h4 class="red--text">* input text and enter for search</h4>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete v-model="search_status" :items="status" label="Status" outlined dense
                @change="findAllByAPISearch" clearable @click:clear="
                  $nextTick(() => {
                    search_status = '';
                    findAllByAPISearch();
                  })
                  "></v-autocomplete>
            </v-col>
            <v-col cols="12" md="1"> </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-end mb-6">
          <v-btn class="mr-2" @click="showsearchmore">
            {{ setlanguage.adddata }}
            <v-icon right>{{ seticonsearchmore.icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-show="toggleEnable">
        <v-col cols="12" md="3">
          <v-autocomplete v-model="company_search" :items="company_list" item-text="company_name"
            item-value="company_code" label="Company Name" outlined dense clearable @click:clear="
              $nextTick(() => {
                company_search = '';
                findAllByAPISearch();
              })
              " @change="findAllByAPISearch"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="department_search" :items="department_list" label="Department"
            item-text="department_name" item-value="id" outlined dense clearable @click:clear="
              $nextTick(() => {
                department_search = 0;
                findAllByAPISearch();
              })
              " @change="findAllByAPISearch"></v-autocomplete>
        </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="computeddatefromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" outlined dense clearable @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                    findAllByAPISearch();
                  })
                  " @input="findAllByAPISearch"></v-text-field>
            </template>
            <v-date-picker v-model="datefrom" @input="menu = false" @change="findAllByAPISearch"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="computeddateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" outlined dense clearable @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                    findAllByAPISearch();
                  })
                  " @input="findAllByAPISearch"></v-text-field>
            </template>
            <v-date-picker v-model="dateto" @input="menu2 = false" @change="findAllByAPISearch"></v-date-picker>
          </v-menu>
        </v-col>
        <!-- <v-col align="right" cols="12" xl="1" lg="1" md="1"></v-col>
      <v-col align="right" cols="12" xl="2" lg="2" md="2">
          <v-autocomplete
            v-model="search"
            :items="status"
            label="Status"
            outlined
            dense
          ></v-autocomplete>
        </v-col> -->
      </v-row>

      <br />

      <v-card outlined tile>
        <!-- <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1   595959"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              depressed
              class="mx-2"
              color="#C8E0FE"
              x-small
              @click="onClicktonewinvoice(item.id)"
            >
              select
            </v-btn>

            <v-btn
              depressed
              class="mx-2"
              color="blue darken-1"
              outlined
              x-small
              @click="getselecttitle(item.id, item.currency)"
              v-if="item.status !== 'Draft'"
            >
              print
            </v-btn>
          </template>
        </v-data-table> -->

        <!-- Pagination Section -->
        <div>
          <v-select v-model="itemsPerPage" @change="onSearchPagination" style="width: 150px" :items="item_per_page_list"
            label="Items per page" dense outlined hide-details></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
              total-visible="19"></v-pagination>
          </div>

          <v-data-table :headers="headers" :items="mDataArray2" :server-items-length="Number(totalItems)"
            :options.sync="options" @update:options="onOptionsUpdate" hide-default-footer class="elevation-1"
            :loading="tableLoading" loading-text="Loading... Please wait">
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular indeterminate color="primary" size="50" width="8"></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn depressed class="mx-2" color="#C8E0FE" x-small @click="onClicktonewinvoice(item.id)">
                select
              </v-btn>

              <v-btn depressed class="mx-2" color="blue darken-1" outlined x-small
                @click="getselecttitle(item.id, item.currency)" v-if="item.status !== 'Draft'">
                print
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-card>

    <template>
      <!-- 
            v-for="index in datashowAll.length"
            v-if="datashowAll.length >= 0 || pageAll >= 0" -->
      <!--   :style="showprint" -->
      <div v-if="datashowAll.length >= 0 || pageAll >= 0" id="mydivhtmltobase" :style="showprint">
        <PrintInvoiceDejTab v-if="getcompany_id == 1" :datashowAll="datashowAll" :print_header="print_header"
          :heighttabledetail="heighttabledetail" :company_inv_prindej="company_inv_prindej"
          :datashowAlltimesheet="datashowAlltimesheet" :haveSO="haveSO" :showcurrency="showcurrency"
          :check_cus_name="check_cus_name" :textamount_total_en="textamount_total_en"
          :datashowAlltimekeeper="datashowAlltimekeeper" :checklawoffice="checklawoffice"></PrintInvoiceDejTab>
        <PrintInvoiceStandardTab v-if="getcompany_id !== 1" :datashowAll="datashowAll" :print_header="print_header"
          :heighttabledetail="heighttabledetail" :datashowAlltimesheet="datashowAlltimesheet" :haveSO="haveSO"
          :showcurrency="showcurrency" :check_cus_name="check_cus_name" :textamount_total_en="textamount_total_en"
          :datashowAlltimekeeper="datashowAlltimekeeper" :checklawoffice="checklawoffice"></PrintInvoiceStandardTab>
      </div>
    </template>

    <v-row justify="center">
      <v-dialog v-model="dialogPrintOut" scrollable max-width="300px">
        <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              Open Dialog
            </v-btn>
          </template> -->
        <v-card>
          <v-card-title>Select Company</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: auto">
            <v-radio-group v-model="dialogPrintOutData" column>
              <v-radio label="บริษัท เดชอุดม จำกัด" value="1" se></v-radio>
              <v-radio label="สำนักกฎหมาย เดชอุดม" value="2"></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" outlined @click="dialogPrintOut = false">
              Cancel
            </v-btn>
            <v-btn color="blue darken-1" outlined @click="tosoforinvoice">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialogSelectTitle" scrollable max-width="35%">
        <v-card class="pa-4">
          <v-card-title class="text-h5 font-weight-bold pb-6">
            Select Document Type
          </v-card-title>

          <v-card-text style="height: auto" class="px-6">
            <v-radio-group v-model="dialogSelectTitleData" column>
              <v-radio label="Statement" value="1" class="mb-2"></v-radio>
              <v-radio label="Invoice" value="2" class="mb-2"></v-radio>
              <v-radio label="Proforma Invoice" value="3" class="mb-2"></v-radio>
            </v-radio-group>

            <v-divider class="my-6"></v-divider>

            <div class="d-flex align-center mb-4">
              <span class="text-h5 font-weight-bold">Select Client Information</span>
              <v-tooltip bottom max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#106a94" class="ml-2" v-bind="attrs" v-on="on">
                    mdi-help-circle
                  </v-icon>
                </template>
                <div class="pa-2">
                  <div>
                    Primary/Secondary client information may be in either
                    English or Thai,
                  </div>
                  <div>
                    depending on how it was entered in the client directory.
                  </div>
                  <div>
                    You can Print Preview first to confirm the language before
                    final printing.
                  </div>
                </div>
              </v-tooltip>
            </div>

            <v-radio-group v-model="dialogSelectClientInfo" column>
              <v-radio label="Primary Information" value="primary" class="mb-2"></v-radio>
              <v-radio label="Secondary Information" value="secondary" class="mb-2"></v-radio>
            </v-radio-group>
          </v-card-text>

          <v-card-actions class="px-6 pt-4">
            <v-row no-gutters>
              <v-col cols="6" class="pr-2">
                <v-btn color="#106a94" large rounded dark elevation="0" @click="toprintfromselecttitle" block>
                  Print Preview
                </v-btn>
              </v-col>
              <v-col cols="6" class="pl-2">
                <v-btn color="#fc1526" large rounded dark elevation="0" @click="dialogSelectTitle = false" block>
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import PrintInvoiceDejTab from "./PrintInvoiceDejTab";
import PrintInvoiceStandardTab from "./PrintInvoiceStandardTab";
var convert = require("decimal-number-to-words");
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";

import pdfInvoiceGenerator from "@/utils/pdfInvoiceGenerator";

export default {
  name: "invoice",
  data(vm) {
    return {
      textamount_total_en: "",
      // เพิ่มตัวแปรใหม่สำหรับ pdfMake
      statementData: null, // เก็บข้อมูลสำหรับสร้าง PDF
      pdfMakeReady: false, // เช็คว่า pdfMake โหลดเสร็จหรือยัง

      dialogSelectClientInfo: "primary",

      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      getcompany_id: localStorage.getItem(server.COMPANYID),
      department_search: 0,
      company_search: 0,
      haveSO: false,
      haveAD: false,
      indexinvADMIS: false,
      search_status: "",
      showprint: "display:none;",
      inv_id: 0,
      dialogPrintOutData: "1",
      dialogPrintOut: false,
      dialogSelectTitleData: "1",
      dialogSelectTitle: false,
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "P.invoice", "Invoice", "Void"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [
        {
          id: "97",
          date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
          customer: "testcus",
          status: "Draft",
        },
      ],
      check_cus_name: false,
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      headers: [
        {
          text: "Invoice No.",
          value: "invoice_no",
          class: "bg-colorth tabletextwhite",
          width: "100px",
        },
        {
          text: "Date",
          value: "date_show",
          class: "bg-colorth tabletextwhite",
          width: "103px",
        },
        {
          text: "Client ID",
          value: "customer_cust_account",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Client Name",
          value: "customer_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Amount",
          value: "amount_show",
          class: "bg-colorth tabletextwhite",
          align: "end",
        },
        {
          text: "Currency",
          value: "currency",
          class: "bg-colorth tabletextwhite",
        },

        {
          text: "",
          value: "actions",
          class: "bg-colorth tabletextwhite",
          width: "185px",
          sortable: false,
        },
      ],
      company_list: [
        {
          company_name: "บริษัท เดชอุดม จำกัด",
          company_code: "D",
        },
        {
          company_name: "สำนักงานทนายความ",
          company_code: "L",
        },
      ],
      print_header_list: [
        {
          id: "1",
          com_title: "STATEMENT",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
          customer_paymentterm: "0",
          credit_term_date: "",
        },
        {
          id: "2",
          com_title: "STATEMENT",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
          customer_paymentterm: "0",
          credit_term_date: "",
        },
      ],
      print_header: {},
      print_table_detail: [],
      pageAll: 1,
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      dataforshowprpo: [],
      getheightcontentpr: 0,
      opensummarizetimesheet: false,
      pageAlltimesheet: 1,
      setdatatoshowtimesheet: [],
      print_table_detailtimesheet: [],
      datashowAlltimesheet: [],
      print_detail_timekeeper: [],
      datashowAlltimekeeper: [],
      showcurrency: "",
      item_id: 0,
      itemcurrency: [],
      checklawoffice: false,
      heighttabledetail: "546px",
      company_inv_prindej: "D",
    };
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.headers = language.en.headertable;
    // this.initialize();
  },
  beforeUpdate() { },
  components: {
    PrintInvoiceDejTab,
    PrintInvoiceStandardTab,
  },
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },

    // ====================================================================
    // Computed properties สำหรับ PDF (เพิ่มใน computed section)
    // หรือถ้าไม่มี computed ให้สร้าง getter functions แทน
    // ====================================================================
    header() {
      return this.statementData?.print_header || {};
    },
    items() {
      if (
        this.statementData?.datashowAll &&
        this.statementData.datashowAll.length > 0
      ) {
        // ← รวมทุกหน้าเข้าด้วยกัน
        return this.statementData.datashowAll.flat() || [];
      }
      return [];
    },

    // items() {
    //   if (
    //     this.statementData?.datashowAll &&
    //     this.statementData.datashowAll.length > 0
    //   ) {
    //     return this.statementData.datashowAll[0] || [];
    //   }
    //   return [];
    // },

    subtotal() {
      return this.header.sub_total || 0;
    },

    withholdingTax() {
      return this.header.wth_rate_amount || 0;
    },

    vat() {
      return this.header.tax_rate_amount || 0;
    },

    grandTotal() {
      return this.header.amount_total || 0;
    },

    withholdingTaxRate() {
      return this.header.wth_rate || "3.00";
    },

    vatRate() {
      return this.header.tax_rate || "7.00";
    },

    currency() {
      return this.statementData?.showcurrency || "USD";
    },

    dynamicItemsPerPage() {
      const totalItems = this.items.length;
      // ถ้าไม่เกิน 8 บรรทัด ใช้ 8, ถ้ามากกว่าใช้ 13
      return totalItems <= 8 ? 8 : 13;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    // await this.loaddataInvoice();
    await this.loadDepartmentByCompanyId();
    this.$hideLoader();
  },
  methods: {
    // 1. เพิ่มฟังก์ชัน findAllByAPISearch
    async findAllByAPISearch() {
      await this.onSearchPagination();
    },

    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      var department_data = 0;
      if (Number(localStorage.getItem(server.USER_ID)) == 1) {
        department_data = 88;
      } else {
        department_data = localStorage.getItem(server.DEPARTMENT_ID);
      }

      try {
        const result = await api.billing_expense_getdataInvoice_HBycompany_Pagination_V2(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          department_data,
          this.company_search,
          this.department_search,
          this.search_status,
          this.datefrom,
          this.dateto,
          this.search,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          if (item.inv_id) {
            item.invoice_no = item.inv_id;
          } else if (item.pinv_id) {
            item.invoice_no = item.pinv_id;
          } else {
            item.invoice_no = "####";
          }
          item.amount_show = tolocalestringnumber(item.inv_amount);
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        // console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.$showLoader()
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }
      var department_data = 0;
      if (Number(localStorage.getItem(server.USER_ID)) == 1) {
        department_data = 88;
      } else {
        department_data = localStorage.getItem(server.DEPARTMENT_ID);
      }
      try {
        const result = await api.billing_expense_getdataInvoice_HBycompany_Pagination_V2(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.COMPANYID),
          department_data,
          this.company_search,
          this.department_search,
          this.search_status,
          this.datefrom,
          this.dateto,
          this.search,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          if (item.inv_id) {
            item.invoice_no = item.inv_id;
          } else if (item.pinv_id) {
            item.invoice_no = item.pinv_id;
          } else {
            item.invoice_no = "####";
          }
          item.amount_show = tolocalestringnumber(item.inv_amount);
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;

        this.$hideLoader()
      } catch (error) {
        // console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        var department_data = 0;
        if (Number(localStorage.getItem(server.USER_ID)) == 1) {
          department_data = 88;
        } else {
          department_data = localStorage.getItem(server.DEPARTMENT_ID);
        }
        const result = await api.billing_expense_getdataInvoice_HBycompany_Pagination_V2(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          department_data,
          this.company_search,
          this.department_search,
          this.search_status,
          this.datefrom,
          this.dateto,
          this.search,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          if (item.inv_id) {
            item.invoice_no = item.inv_id;
          } else if (item.pinv_id) {
            item.invoice_no = item.pinv_id;
          } else {
            item.invoice_no = "####";
          }
          item.amount_show = tolocalestringnumber(item.inv_amount);
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        // console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      // var s_data = {
      //   page: 1,
      //   limit: this.itemsPerPage,
      //   sortBy: "id",
      //   sortOrder: "ASC",
      //   company_id: localStorage.getItem(server.COMPANYID),
      //   department_id: localStorage.getItem(server.DEPARTMENT_ID),
      // };

      try {
        var department_data = 0;
        if (Number(localStorage.getItem(server.USER_ID)) == 1) {
          department_data = 88;
        } else {
          department_data = localStorage.getItem(server.DEPARTMENT_ID);
        }

        const result = await api.billing_expense_getdataInvoice_HBycompany_Pagination_V2(
          1,
          this.itemsPerPage,
          "id",
          "DESC",
          localStorage.getItem(server.COMPANYID),
          department_data,
          this.company_search,
          this.department_search,
          this.search_status,
          this.datefrom,
          this.dateto,
          this.search,
        );

        // //console.log(`onSearchPagination result:`, JSON.stringify(result));

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          if (item.inv_id) {
            item.invoice_no = item.inv_id;
          } else if (item.pinv_id) {
            item.invoice_no = item.pinv_id;
          } else {
            item.invoice_no = "####";
          }
          item.amount_show = tolocalestringnumber(item.inv_amount);
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        // console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async loadDepartmentByCompanyId() {
      let result = await api.getNewAllDepartment_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );
      this.department_list = result.data;
    },
    async exportToPDF(advance_id) {
      let main_data_to_print = {
        main_data: {
          datashowAll: this.datashowAll,
          print_header: this.print_header,
          heighttabledetail: this.heighttabledetail,
          company_inv_prindej: this.company_inv_prindej,
          datashowAlltimesheet: this.datashowAlltimesheet,
          haveSO: this.haveSO,
          showcurrency: this.showcurrency,
          check_cus_name: this.check_cus_name,
          textamount_total_en: this.textamount_total_en,
          datashowAlltimekeeper: this.datashowAlltimekeeper,
          checklawoffice: this.checklawoffice,
        },
      };


      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,

        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },

      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });

      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    getPrintDialog(item_id) {
      this.inv_id = item_id;
      if (
        localStorage.getItem(server.COMPANYID) == "1" ||
        localStorage.getItem(server.COMPANYID) == 1
      ) {
        this.dialogPrintOut = true;
      } else {
        this.$router.push(
          `/so-for-invoice/${localStorage.getItem(server.COMPANYID)}`,
        );
      }
    },
    async tosoforinvoice() {
      let company_inv = "";
      if (this.dialogPrintOutData == "1") {
        company_inv = "D";
      } else if (this.dialogPrintOutData == "2") {
        company_inv = "L";
      } else {
      }
      this.$router.push(`/so-for-invoice/${company_inv}`);
    },
    async getselecttitle(item_id, itemcurrency) {
      if (

        localStorage.getItem(server.COMPANYID) == "1" ||
        localStorage.getItem(server.COMPANYID) == 1
      ) {
        this.dialogSelectTitleData = "1";
        this.item_id = item_id;
        this.itemcurrency = itemcurrency;
        this.dialogSelectTitle = true;
      } else {
        this.item_id = item_id;
        this.itemcurrency = itemcurrency;
        await this.getPrintOutData();
      }
    },
    async toprintfromselecttitle() {
      if (this.dialogSelectTitleData == "1") {
        this.print_header_list[0].com_title = "STATEMENT";
        this.print_header_list[1].com_title = "STATEMENT";
      } else if (this.dialogSelectTitleData == "2") {
        this.print_header_list[0].com_title = "INVOICE";
        this.print_header_list[1].com_title = "INVOICE";
      } else if (this.dialogSelectTitleData == "3") {
        this.print_header_list[0].com_title = "Proforma Invoice";
        this.print_header_list[1].com_title = "Proforma Invoice";
      } else {
        this.print_header_list[0].com_title = "";
        this.print_header_list[1].com_title = "";
      }
      this.$showLoader();

      await this.getPrintOutData();
      this.$hideLoader();
      this.dialogSelectTitle = false;
    },
    async getPrintOutData(item_id, itemcurrency) {
      this.inv_id = this.item_id;
      this.showcurrency = this.itemcurrency;
      this.showcurrency = this.showcurrency.replace("US", "USD");
      this.showcurrency = this.showcurrency.replace("USDD", "USD");

      // this.showprint = "";
      this.haveSO = false;
      this.haveAD = false;
      this.datashowAll = [];
      this.print_table_detail = [];
      this.print_table_detailtimesheet = [];
      this.print_detail_timekeeper = [];
      this.dialogPrintOut = false;

      await this.loadRef_TypeCNById();
      await this.loadInvSoData();
      await this.loadInvDocRefData();
      await this.loadInvTSGetTimekeeper();

      await this.loadInvMISData();
      await this.checkcontent();
      await this.checkcontenttimesheet();
      await this.exportToPDFBypdfMake();

    },

    async exportToPDFBypdfMake() {
      try {

        const invoiceData = {
          datashowAll: this.datashowAll,
          print_header: this.print_header,
          heighttabledetail: this.heighttabledetail,
          company_inv_prindej: this.company_inv_prindej,
          datashowAlltimesheet: this.datashowAlltimesheet,
          haveSO: this.haveSO,
          showcurrency: this.showcurrency,
          check_cus_name: this.check_cus_name,
          textamount_total_en: this.textamount_total_en,
          datashowAlltimekeeper: this.datashowAlltimekeeper,
          checklawoffice: this.checklawoffice,
        };


        await pdfInvoiceGenerator.exportToPDF(invoiceData);
      } catch (error) {
        // console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    async exportToPDFBypdfMake2(advance_id) {
      // เตรียมข้อมูลสำหรับปริ้น
      let main_data_to_print = {
        main_data: {
          datashowAll: this.datashowAll,
          print_header: this.print_header,
          heighttabledetail: this.heighttabledetail,
          company_inv_prindej: this.company_inv_prindej,
          datashowAlltimesheet: this.datashowAlltimesheet,
          haveSO: this.haveSO,
          showcurrency: this.showcurrency,
          check_cus_name: this.check_cus_name,
          textamount_total_en: this.textamount_total_en,
          datashowAlltimekeeper: this.datashowAlltimekeeper,
          checklawoffice: this.checklawoffice,
        },
      };

      // เก็บข้อมูลไว้ใน this.statementData เพื่อให้ฟังชั่นอื่นเข้าถึงได้
      this.statementData = main_data_to_print.main_data;

      // //console.log(`statementData:${JSON.stringify(this.statementData)}`);

      // รอให้ pdfMake พร้อมใช้งาน
      try {
        await this.waitForPdfMakeReady();
      } catch (error) {
        // console.error("❌ pdfMake ไม่พร้อมใช้งาน:", error);
        alert("ไม่สามารถโหลดระบบ PDF ได้ กรุณาลองใหม่อีกครั้ง");
        return;
      }

      // สร้าง PDF
      try {
        const docDefinition = this.generateCombinedDocDefinitionForInvoice();

        // เปิด PDF ใหม่ในแท็บใหม่
        pdfMake.createPdf(docDefinition).open();
        // //console.log("✅ สร้าง PDF สำเร็จ (ORIGINAL + COPY)");
      } catch (error) {
        // console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    // ====================================================================
    // ฟังชั่นรอให้ pdfMake พร้อมใช้งาน
    // ====================================================================
    waitForPdfMakeReady() {
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
            clearInterval(checkInterval);
            // //console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
            resolve(true);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("pdfMake โหลดไม่สำเร็จ"));
        }, 10000);
      });
    },

    // ====================================================================
    // ฟังชั่นจัดฟอร์แมตตัวเลข
    // ====================================================================
    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    // ====================================================================
    // ฟังชั่นจัดฟอร์แมตวันที่
    // ====================================================================
    formatDate(dateString) {
      if (!dateString) return "";
      if (dateString.includes("/")) {
        return dateString;
      }

      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วนผลรวมและ footer (ใช้เฉพาะหน้าสุดท้าย)
    // คัดลอกมาจาก StatementpdfV3.vue เป๊ะๆ
    // ====================================================================
    // ====================================================================
    // ฟังชั่นสร้างเนื้อหาหลักของ Statement (ปรับปรุงแล้ว)
    // ====================================================================

    generateSummaryAndFooter() {
      return [
        // ตารางสรุปยอดเงิน
        {
          table: {
            widths: ["*", 120],
            body: [
              [
                {
                  text: "Sub Total / รวมเป็นเงิน",
                  fontSize: 10,
                  border: [true, true, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text:
                    this.formatNumber(this.subtotal) + " " + this.showcurrency,
                  fontSize: 10,
                  alignment: "right",
                  border: [true, true, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: `Less Withholding Tax / ภาษีหัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                  fontSize: 10,
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text:
                    this.formatNumber(this.withholdingTax) +
                    " " +
                    this.showcurrency,
                  fontSize: 10,
                  alignment: "right",
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                  fontSize: 10,
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text: this.formatNumber(this.vat) + " " + this.showcurrency,
                  fontSize: 10,
                  alignment: "right",
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: "Grand Total / ยอดรวม",
                  fontSize: 10,
                  bold: true,
                  border: [true, false, true, true],
                  margin: [5, 3, 5, 3],
                },
                {
                  text:
                    this.formatNumber(this.grandTotal) +
                    " " +
                    this.showcurrency,
                  fontSize: 10,
                  bold: true,
                  alignment: "right",
                  border: [true, false, true, true],
                  margin: [5, 3, 5, 3],
                },
              ],
            ],
          },
          layout: {
            paddingLeft: function () {
              return 0;
            },
            paddingRight: function () {
              return 0;
            },
            paddingTop: function () {
              return 0;
            },
            paddingBottom: function () {
              return 0;
            },
          },
          margin: [0, 0, 0, 5],
        },

        // จำนวนเงินตัวอักษร
        {
          text: amountInWords,
          fontSize: 10,
          bold: true,
          alignment: "center",
          margin: [0, 5, 0, 10],
        },

        // ข้อความ Please send
        {
          stack: [
            {
              text:
                "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                "โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 10],
            },
          ],
        },

        // Disclaimer
        {
          stack: [
            {
              text: "Cybersecurity & Wire Transfer Disclaimer",
              fontSize: 8,
              bold: true,
              color: "red",
              margin: [0, 0, 0, 2],
            },
            {
              text: disclaimerText,
              fontSize: 7,
              bold: true,
              color: "red",
              alignment: "justify",
            },
          ],
        },
      ];
    },

    // ====================================================================
    // ฟังชั่นสร้างเนื้อหาหลักของ Statement
    // คัดลอกมาจาก StatementpdfV3.vue เป๊ะๆ
    // ====================================================================
    generateMainStatement(documentType = "ORIGINAL") {
      const mainContent = [];
      const itemsPerPage = this.dynamicItemsPerPage; // ใช้ค่าแบบไดนามิก

      // ตรวจสอบชื่อบริษัทเพื่อกำหนดข้อความ Disclaimer
      const isLawOffice =
        this.header.com_thai === "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์";
      // //console.log(`isLawOffice: ${isLawOffice}`);
      const disclaimerText = isLawOffice
        ? "Dej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt."
        : "Dej-Udom & Associates Ltd. shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates Ltd. for verification if in doubt.";
      // //console.log(`disclaimerText: ${disclaimerText}`);

      // ตรวจสอบภาษาของ customer_name เพื่อกำหนดรูปแบบจำนวนเงินตัวอักษร
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(this.header.customer_name || "");

      // กำหนดข้อความจำนวนเงินตัวอักษร
      let amountInWords = "";
      if (isThaiCustomer) {
        // ถ้าชื่อลูกค้าเป็นภาษาไทย → แสดงจำนวนเงินเป็นภาษาไทย
        amountInWords = this.statementData.textamount_total_en || "";
      } else {
        // ถ้าชื่อลูกค้าเป็นภาษาอังกฤษ → แสดงจำนวนเงินเป็นภาษาอังกฤษ พร้อม currency
        amountInWords = `(${this.statementData.textamount_total_en || ""}) ${this.currency
          }`;
      }

      //replace US to USD
      amountInWords = amountInWords.replace("US", "USD");
      amountInWords = amountInWords.replace("USDD", "USD");
      // //console.log(`amountInWords: ${amountInWords}`);

      // ===== หน้าที่ 1 =====
      mainContent.push(
        // Header บริษัท
        {
          columns: [
            {
              width: "50%",
              stack: [
                {
                  text: this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 1],
                },
                {
                  text: this.header.com_eng_2 || "ATTORNEYS AT LAW",
                  fontSize: 9,
                  margin: [0, 0, 0, 2],
                },
                {
                  text:
                    this.header.com_thai ||
                    "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                  fontSize: 11,
                  margin: [0, 0, 0, 1],
                },
              ],
            },
            {
              width: "50%",
              stack: [
                {
                  text:
                    this.header.com_add_name ||
                    "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: this.header.com_add_no || "942/69 RAMA IV ROAD,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_city ||
                    "KWAENG SURIYAWONG, KHET BANGRAK,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_country || "BANGKOK 10500, THAILAND",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_tel || "Tel : 0-2233-0055, 0-2267-5152",
                  fontSize: 8,
                  alignment: "right",
                  margin: [0, 2, 0, 0],
                },
                {
                  text:
                    this.header.com_add_email || "E-MAIL : account@dejudom.com",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_tax_id ||
                    'TAX ID. No. 0105534015348/"HEAD OFFICE"',
                  fontSize: 8,
                  alignment: "right",
                  bold: true,
                },
              ],
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // STATEMENT พร้อม ORIGINAL/COPY
        {
          columns: [
            {
              width: "70%",
              text: this.header.com_title || "STATEMENT",
              fontSize: 18,
              bold: true,
            },
            {
              width: "30%",
              stack: [
                {
                  text: documentType,
                  fontSize: 11,
                  bold: true,
                  alignment: "right",
                  margin: [0, 0, 0, 2],
                },
                {
                  text: `No. / เลขที่ : ${this.header.inv_id || ""}`,
                  fontSize: 10,
                  alignment: "right",
                },
              ],
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // เส้นคั่น
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 545, // ปรับจาก 515 เป็น 545 เพราะ padding น้อยลง
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // ข้อมูลลูกค้า
        {
          columns: [
            {
              width: "55%",
              stack: [
                {
                  text: [
                    { text: "To / ถึง:  ", fontSize: 10 },
                    {
                      text: this.header.customer_name || "",
                      fontSize: 10,
                      bold: true,
                    },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  text: (this.header.addressall || "").split("\n"),
                  fontSize: 9,
                  margin: [0, 0, 0, 5],
                },
                {
                  text: `Tax ID: ${this.header.customer_taxid || "0"}`,
                  fontSize: 9,
                  margin: [0, 3, 0, 2],
                },
                {
                  text: `Attention : ${this.header.attention ||
                    this.header.customer_contact_name ||
                    "-"}`,
                  fontSize: 9,
                },
              ],
            },
            {
              width: "45%",
              stack: [
                {
                  text: `Date / วันที่: ${this.header.invoice_date ? this.header.invoice_date : "-"
                    }`,
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 0, 0, 8],
                },
                {
                  text: `Period Covered / รอบระยะเวลา : ${this.header
                    .period_cover || "-"}`,
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 0, 0, 2],
                },
                {
                  text: `Document Ref. : ${this.header.docref || "-"}`,
                  fontSize: 9,
                  alignment: "right",
                },
                {
                  text: `Credit Term : ${this.header.customer_paymentterm ||
                    "-"} Days`,
                  fontSize: 9,
                  alignment: "right",
                },
                {
                  text: `Due Date : ${this.header.credit_term_date || "-"}`,
                  fontSize: 9,
                  alignment: "right",
                },
              ],
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // ตาราง หน้า 1 - ความสูงคงที่เต็มหน้า A4
        {
          table: {
            headerRows: 1,
            widths: ["*", 120],
            heights: (row) => {
              if (row === 0) return "auto"; // header
              // กำหนดความสูงคงที่สำหรับแต่ละแถว
              return 35; // ความสูงแต่ละบรรทัด 35pt
            },
            body: (() => {
              const tableBody = [
                [
                  {
                    text: "Description / รายการ",
                    fontSize: 10,
                    bold: true,
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "Amount / จำนวนเงิน",
                    fontSize: 10,
                    bold: true,
                    alignment: "right",
                    margin: [5, 5, 5, 5],
                  },
                ],
              ];

              // เพิ่มข้อมูลจริงก่อน
              for (let i = 0; i < this.items.length && i < itemsPerPage; i++) {
                const item = this.items[i];
                tableBody.push([
                  {
                    text:
                      (item.first_item === 1 && item.report_type === "ADMIS"
                        ? "Miscellaneous Disbursement:\n"
                        : "") + (item.report_desc || ""),
                    fontSize: 9,
                    bold: item.first_item === 1 && item.report_type === "ADMIS",
                    margin: [5, 5, 5, 5],
                    lineHeight: 1.2,
                  },
                  {
                    text:
                      item.report_amount && item.report_amount !== 0
                        ? this.formatNumber(item.report_amount)
                        : "",
                    fontSize: 9,
                    alignment: "right",
                    margin: [5, 5, 5, 5],
                  },
                ]);
              }

              // คำนวณจำนวนแถวว่างที่ต้องเติม
              const usedRows = Math.min(this.items.length, itemsPerPage);
              const emptyRowsNeeded = itemsPerPage - usedRows;

              // เติมแถวว่างให้ครบ
              for (let i = 0; i < emptyRowsNeeded; i++) {
                tableBody.push([
                  {
                    text: "",
                    fontSize: 9,
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "",
                    fontSize: 9,
                    alignment: "right",
                    margin: [5, 5, 5, 5],
                  },
                ]);
              }

              // เพิ่มแถว IMPORTANT (ถ้ามี)
              if (this.currency !== "THB") {
                tableBody.push([
                  {
                    text:
                      "IMPORTANT: Payment must be paid in full, without deductions of foreign bank fees or taxes;\nwe will solely be responsible for Thai tax.",
                    fontSize: 8,
                    italics: true,
                    bold: true,
                    margin: [5, 5, 5, 5],
                  },
                  {},
                ]);
              } else {
                // เติมแถวว่างแทน
                tableBody.push([
                  {
                    text: "",
                    fontSize: 9,
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "",
                    fontSize: 9,
                    alignment: "right",
                    margin: [5, 5, 5, 5],
                  },
                ]);
              }

              return tableBody;
            })(),
          },
          layout: {
            hLineWidth: function (i, node) {
              //  if (i === 0 || i === 1 || i === node.table.body.length) {
              if (i === 0 || i === 1) {
                return 1;
              }
              return 0; // ไม่มีเส้นคั่นระหว่างแถว
            },
            vLineWidth: function (i) {
              return 1;
            },
            paddingLeft: function () {
              return 0;
            },
            paddingRight: function () {
              return 0;
            },
            paddingTop: function () {
              return 0;
            },
            paddingBottom: function () {
              return 0;
            },
          },
          margin: [0, 0, 0, 0],
        },
      );

      // ===== หน้าที่ 2+ ของ Statement (ถ้ามีข้อมูลเกิน 15 รายการ) =====
      const remainingItems = this.items.length - itemsPerPage;

      if (remainingItems > 0) {
        const itemsPerContinuedPage = 20; // ลดจาก 25 เป็น 20 เพื่อไม่ให้เกินกระดาษ
        const additionalPages = Math.ceil(
          remainingItems / itemsPerContinuedPage,
        );

        for (let page = 0; page < additionalPages; page++) {
          const startIdx = itemsPerPage + page * itemsPerContinuedPage;
          const endIdx = Math.min(
            startIdx + itemsPerContinuedPage,
            this.items.length,
          );
          const isLastPage = endIdx === this.items.length;

          mainContent.push(
            { text: "", pageBreak: "before" },

            {
              text: "STATEMENT (Continued)",
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 15],
            },

            // ตารางหน้า 2+ (Continued)
            {
              table: {
                headerRows: 1,
                widths: ["*", 120],
                heights: (row) => {
                  if (row === 0) return "auto"; // header
                  return 35; // ความสูงคงที่เหมือนหน้าแรก
                },
                body: (() => {
                  const tableBody = [
                    [
                      {
                        text: "Description / รายการ",
                        fontSize: 10,
                        bold: true,
                        margin: [5, 5, 5, 5],
                      },
                      {
                        text: "Amount / จำนวนเงิน",
                        fontSize: 10,
                        bold: true,
                        alignment: "right",
                        margin: [5, 5, 5, 5],
                      },
                    ],
                  ];

                  // เพิ่มข้อมูลจริงของหน้านี้
                  const itemsInThisPage = this.items.slice(startIdx, endIdx);

                  itemsInThisPage.forEach((item) => {
                    tableBody.push([
                      {
                        text:
                          (item.first_item === 1 && item.report_type === "ADMIS"
                            ? "Miscellaneous Disbursement:\n"
                            : "") + (item.report_desc || ""),
                        fontSize: 9,
                        bold:
                          item.first_item === 1 && item.report_type === "ADMIS",
                        margin: [5, 5, 5, 5],
                        lineHeight: 1.2,
                      },
                      {
                        text:
                          item.report_amount && item.report_amount !== 0
                            ? this.formatNumber(item.report_amount)
                            : "",
                        fontSize: 9,
                        alignment: "right",
                        margin: [5, 5, 5, 5],
                      },
                    ]);
                  });

                  // ถ้าไม่ใช่หน้าสุดท้าย ให้เติมแถวว่างให้เต็มหน้า
                  if (!isLastPage) {
                    const usedRows = itemsInThisPage.length;
                    const emptyRowsNeeded = itemsPerContinuedPage - usedRows;

                    for (let i = 0; i < emptyRowsNeeded; i++) {
                      tableBody.push([
                        {
                          text: "",
                          fontSize: 9,
                          margin: [5, 5, 5, 5],
                        },
                        {
                          text: "",
                          fontSize: 9,
                          alignment: "right",
                          margin: [5, 5, 5, 5],
                        },
                      ]);
                    }
                  }

                  return tableBody;
                })(),
              },
              layout: {
                hLineWidth: function (i, node) {
                  if (i === 0 || i === 1 || i === node.table.body.length) {
                    return 1;
                  }
                  return 0;
                },
                vLineWidth: function (i) {
                  return 1;
                },
                paddingLeft: function () {
                  return 0;
                },
                paddingRight: function () {
                  return 0;
                },
                paddingTop: function () {
                  return 0;
                },
                paddingBottom: function () {
                  return 0;
                },
              },
              margin: [0, 0, 0, isLastPage ? 0 : 0],
            },
          );

          // *** ถ้าเป็นหน้าสุดท้าย ให้เพิ่มผลรวมและ footer ***
          if (isLastPage) {
            mainContent.push(
              // สรุปยอดเงิน (ปรับให้มีจำนวนเงินตัวอักษรอยู่ใน table)
              {
                table: {
                  widths: ["*", 120],
                  body: [
                    [
                      {
                        text: "Sub Total / รวมเป็นเงิน",
                        fontSize: 10,
                        border: [true, true, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text:
                          this.formatNumber(this.subtotal) +
                          " " +
                          this.showcurrency,
                        fontSize: 10,
                        alignment: "right",
                        border: [true, true, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: `Less Withholding Tax / ภาษีเงินได้หัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                        fontSize: 10,
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text:
                          this.formatNumber(this.withholdingTax) +
                          " " +
                          this.showcurrency,
                        fontSize: 10,
                        alignment: "right",
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                        fontSize: 10,
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text:
                          this.formatNumber(this.vat) + " " + this.showcurrency,
                        fontSize: 10,
                        alignment: "right",
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: "Grand Total / ยอดรวม",
                        fontSize: 11,
                        bold: true,
                        fillColor: "#eeeeee",
                        border: [true, false, true, false],
                        margin: [5, 5, 5, 3],
                      },
                      {
                        text:
                          this.formatNumber(this.grandTotal) +
                          " " +
                          this.showcurrency,
                        fontSize: 11,
                        bold: true,
                        alignment: "right",
                        fillColor: "#eeeeee",
                        border: [true, false, true, false],
                        margin: [5, 5, 5, 3],
                      },
                    ],
                    // *** เพิ่ม: จำนวนเงินตัวอักษรในแถวใหม่ของ table ***
                    [
                      {
                        text: amountInWords,
                        fontSize: 11,
                        bold: true,
                        alignment: "center",
                        fillColor: "#eeeeee",
                        border: [true, false, true, true],
                        margin: [5, 5, 5, 3],
                      },
                      {
                        text: "",
                        fontSize: 11,
                        bold: true,
                        alignment: "right",
                        fillColor: "#eeeeee",
                        border: [true, false, true, true],
                        margin: [5, 5, 5, 3],
                      },
                    ],
                  ],
                },
                layout: {
                  paddingLeft: function () {
                    return 0;
                  },
                  paddingRight: function () {
                    return 0;
                  },
                  paddingTop: function () {
                    return 0;
                  },
                  paddingBottom: function () {
                    return 0;
                  },
                },
                margin: [0, 0, 0, 10],
              },

              // ข้อความ Please send
              {
                stack: [
                  {
                    text:
                      "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
                    fontSize: 8,
                    alignment: "center",
                    margin: [0, 0, 0, 1],
                  },
                  {
                    text:
                      "โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
                    fontSize: 8,
                    alignment: "center",
                    margin: [0, 0, 0, 10],
                  },
                ],
              },

              // Disclaimer
              {
                stack: [
                  {
                    text: "Cybersecurity & Wire Transfer Disclaimer",
                    fontSize: 8,
                    bold: true,
                    color: "red",
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: disclaimerText,
                    fontSize: 7,
                    bold: true,
                    color: "red",
                    alignment: "justify",
                  },
                ],
              },
            );
          }
        }
      } else {
        // *** ถ้ามีรายการไม่เกิน 9 รายการ ให้เพิ่มผลรวมและ footer ในหน้าแรก ***
        mainContent.push(
          // สรุปยอดเงิน หน้า 1 (ปรับให้มีจำนวนเงินตัวอักษรอยู่ใน table)
          {
            table: {
              widths: ["*", 120],
              body: [
                [
                  {
                    text: "Sub Total / รวมเป็นเงิน",
                    fontSize: 10,
                    // border: [true, true, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text:
                      this.formatNumber(this.subtotal) +
                      " " +
                      this.showcurrency,
                    fontSize: 10,
                    alignment: "right",
                    // border: [true, true, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: `Less Withholding Tax / ภาษีเงินได้หัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                    fontSize: 10,
                    // border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text:
                      this.formatNumber(this.withholdingTax) +
                      " " +
                      this.showcurrency,
                    fontSize: 10,
                    alignment: "right",
                    // border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                    fontSize: 10,
                    // border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text: this.formatNumber(this.vat) + " " + this.showcurrency,
                    fontSize: 10,
                    alignment: "right",
                    // border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: "Grand Total / ยอดรวม",
                    fontSize: 11,
                    bold: true,
                    fillColor: "#eeeeee",
                    // border: [true, false, true, false],
                    margin: [5, 5, 5, 3],
                  },
                  {
                    text:
                      this.formatNumber(this.grandTotal) +
                      " " +
                      this.showcurrency,
                    fontSize: 11,
                    bold: true,
                    alignment: "right",
                    fillColor: "#eeeeee",
                    // border: [true, false, true, false],
                    margin: [5, 5, 5, 3],
                  },
                ],
                // *** เพิ่ม: จำนวนเงินตัวอักษรในแถวใหม่ของ table ***
                [
                  {
                    text: amountInWords,
                    fontSize: 10,
                    // bold: true,
                    alignment: "center",
                    fillColor: "#eeeeee",
                    // border: [true, false, true, true],
                    margin: [5, 5, 5, 3],
                    colSpan: 2,
                  },
                  {
                    // text: "",
                    // fontSize: 11,
                    // bold: true,
                    // alignment: "right",
                    // fillColor: "#eeeeee",
                    // border: [true, false, true, true],
                    // margin: [5, 5, 5, 3],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function () {
                return 1;
              },
              vLineWidth: function () {
                return 1;
              },
              hLineColor: function () {
                return "black";
              },
              vLineColor: function () {
                return "black";
              },
              paddingLeft: function () {
                return 0;
              },
              paddingRight: function () {
                return 0;
              },
              paddingTop: function () {
                return 0;
              },
              paddingBottom: function () {
                return 0;
              },
            },
            margin: [0, 0, 0, 10],
          },

          // ข้อความ Please send
          {
            stack: [
              {
                text:
                  "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
                fontSize: 8,
                alignment: "center",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  "โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
                fontSize: 8,
                alignment: "center",
                margin: [0, 0, 0, 10],
              },
            ],
          },

          // Disclaimer
          {
            stack: [
              {
                text: "Cybersecurity & Wire Transfer Disclaimer",
                fontSize: 8,
                bold: true,
                color: "red",
                margin: [0, 0, 0, 2],
              },
              {
                text: disclaimerText,
                fontSize: 7,
                bold: true,
                color: "red",
                alignment: "justify",
              },
            ],
          },
        );
      }

      return mainContent;
    },

    // ====================================================================
    // ฟังชั่นสร้าง PDF Definition ที่มีทั้ง ORIGINAL และ COPY
    // ====================================================================
    generateCombinedDocDefinitionForInvoice() {
      const originalContent = this.generateMainStatement("ORIGINAL");
      const copyContent = this.generateMainStatement("COPY");

      // เพิ่ม pageBreak ให้กับ COPY
      copyContent[0] = {
        ...copyContent[0],
        pageBreak: "before",
      };

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [25, 25, 25, 25],
        content: [...originalContent, ...copyContent],
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },
    async loadRef_TypeCNById() {
      const res_hresult = await api.billing_expense_getPrintDataByIdAndCusTypeInvoice_H(
        this.inv_id,
        this.dialogSelectClientInfo,
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.heighttabledetail = "469px";
        this.company_inv_prindej = "D";
        this.print_header = this.print_header_list[0];
        this.print_header.customer_taxid =
          `${res_hresult.data[0].customer_taxid} ${(res_hresult.data[0].customer_branch && res_hresult.data[0].customer_branch !== "") ? ` / ${res_hresult.data[0].customer_branch}` : ''}`;
        // //console.log(`D this.print_header :`, JSON.stringify(this.print_header));
        this.checklawoffice = false;
      } else if (res_hresult.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.heighttabledetail = "499px";
        this.company_inv_prindej = "L";
        this.print_header = this.print_header_list[1];
        this.print_header.customer_taxid =
          `${res_hresult.data[0].customer_taxid} ${(res_hresult.data[0].customer_branch && res_hresult.data[0].customer_branch !== "") ? ` / ${res_hresult.data[0].customer_branch}` : ''}`;
        // //console.log(`L this.print_header :`, JSON.stringify(this.print_header));
        this.checklawoffice = true;
      } else {
        this.print_header.inv_company_address2 = res_hresult.data[0].inv_company_address2;
        this.print_header.inv_subdistrict = res_hresult.data[0].inv_subdistrict;
        this.print_header.inv_district = res_hresult.data[0].inv_district;
        this.print_header.inv_province = res_hresult.data[0].inv_province;
        this.print_header.inv_postcode = res_hresult.data[0].inv_postcode;
        this.print_header.inv_country = res_hresult.data[0].inv_country;
        this.getcompany_id = res_hresult.data[0].company_inv;
        this.print_header.com_name = res_hresult.data[0].com_name;
        this.print_header.inv_company_address =
          res_hresult.data[0].inv_company_address;
        this.print_header.inv_company_branch =
          res_hresult.data[0].inv_company_branch;
        this.print_header.inv_company_tel = res_hresult.data[0].inv_company_tel;
        this.print_header.inv_company_email =
          res_hresult.data[0].inv_company_email;
        this.print_header.inv_tax_id = res_hresult.data[0].inv_tax_id;
        this.print_header.customer_taxid =
          `${res_hresult.data[0].customer_taxid} ${(res_hresult.data[0].customer_branch && res_hresult.data[0].customer_branch !== "") ? ` / ${res_hresult.data[0].customer_branch}` : ''}`;
        this.print_header.inv_company_name_th =
          res_hresult.data[0].inv_company_name_th;

        if (res_hresult.data[0].inv_type == "I") {
          this.print_header.com_title = "INVOICE";
        } else if (res_hresult.data[0].inv_type == "P") {
          this.print_header.com_title = "Proforma Invoice";
        } else {
          this.print_header.com_title = "";
        }
      }

      this.print_header.customer_paymentterm =
        res_hresult.data[0].customer_paymentterm;
      this.print_header.credit_term_date = res_hresult.data[0].credit_term_date;

      this.print_header.docref = res_hresult.data[0].po_no;
      this.print_header.attention = res_hresult.data[0].attention;
      this.print_header.contact_position = res_hresult.data[0].contact_position;
      this.print_header.inv_id = res_hresult.data[0].inv_id
        ? res_hresult.data[0].inv_id
        : res_hresult.data[0].pinv_id;
      this.print_header.customer_name = res_hresult.data[0].customer_name;
      this.print_header.invoice_date = res_hresult.data[0].date_show;
      this.print_header.addressall = res_hresult.data[0].addressall;
      this.print_header.customer_address = res_hresult.data[0].customer_address;
      this.print_header.company_inv = res_hresult.data[0].company_inv;

      this.print_header.province_invoice = res_hresult.data[0].province_invoice;
      this.print_header.country_invoice = res_hresult.data[0].country_invoice;
      this.print_header.zipcode_invoice = res_hresult.data[0].zipcode_invoice;

      this.print_header.period_cover = res_hresult.data[0].period_cover;
      this.print_header.customer_contact_name =
        res_hresult.data[0].customer_contact_name;
      // this.print_header.customer_taxid = res_hresult.data[0].customer_taxid;
      this.print_header.customer_branch = res_hresult.data[0].customer_branch;

      this.print_header.ts_total = parseFloat(res_hresult.data[0].ts_total);
      this.print_header.sub_total = parseFloat(res_hresult.data[0].sub_total);
      this.print_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_header.tax_rate = res_hresult.data[0].tax_rate;
      this.print_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100,
      );
      this.print_header.tax_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].tax_rate) / 100,
      );

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          res_hresult.data[0].amount_total,
        );

        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        var result = "";

        if (this.showcurrency == "THB") {
          //start เปลี่ยนเป็นตัวอ่านไทย
          // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
          var thaiNumbers = [
            "",
            "หนึ่ง",
            "สอง",
            "สาม",
            "สี่",
            "ห้า",
            "หก",
            "เจ็ด",
            "แปด",
            "เก้า",
          ];
          var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

          // แยกตัวจำนวนเต็มและทศนิยมห
          res_hresult.data[0].amount_total =
            Math.round(res_hresult.data[0].amount_total * 100) / 100;
          var [
            integerPart,
            decimalPart,
          ] = res_hresult.data[0].amount_total.toString().split(".");

          // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
          let de_check = 0;
          if (decimalPart) {
            if (decimalPart.split("").length == 1) {
              if (Number(decimalPart) >= 10) {
                decimalPart = decimalPart;
              } else if (Number(decimalPart) > 0) {
                decimalPart = Number(decimalPart) * 10;
              } else {
                de_check = 1;
              }
            }
          } else {
            de_check = 1;
          }

          let decimalText = "";
          if (de_check == 0) {
            decimalPart = String(decimalPart);

            var numArrays = decimalPart.split("").map(Number);
            numArrays.forEach((num, index) => {
              var units = thaiUnits[numArrays.length - index - 1];
              var digits = thaiNumbers[num];
              if (num !== 0) {
                if (num === 1 && index === numArrays.length - 1) {
                  // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                  decimalText += "เอ็ด" + units;
                } else if (
                  num === 2 &&
                  index === numArrays.length - 2 &&
                  numArrays.length >= 2
                ) {
                  decimalText += "ยี่" + units;
                } else if (
                  num === 1 &&
                  index === numArrays.length - 2 &&
                  numArrays.length >= 2
                ) {
                  decimalText += units;
                } else {
                  decimalText += digits + units;
                }
              }
            });

            decimalText = decimalText + "สตางค์";
          }

          // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
          let integerText = "";

          var numArray = integerPart.split("").map(Number);
          numArray.forEach((num, index) => {
            var unit = thaiUnits[numArray.length - index - 1];
            var digit = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArray.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                integerText += "เอ็ด" + unit;
              } else if (
                num === 2 &&
                index === numArray.length - 2 &&
                numArray.length >= 2
              ) {
                integerText += "ยี่" + unit;
              } else if (
                num === 1 &&
                index === numArray.length - 2 &&
                numArray.length >= 2
              ) {
                integerText += unit;
              } else {
                integerText += digit + unit;
              }
            }
          });

          integerText = integerText + "บาท";

          result = integerText + decimalText;
        } else {
          //start เปลี่ยนเป็นตัวอ่านไทย
          // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
          var thaiNumbers = [
            "",
            "หนึ่ง",
            "สอง",
            "สาม",
            "สี่",
            "ห้า",
            "หก",
            "เจ็ด",
            "แปด",
            "เก้า",
          ];
          var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

          // แยกตัวจำนวนเต็มและทศนิยมห
          res_hresult.data[0].amount_total =
            Math.round(res_hresult.data[0].amount_total * 100) / 100;
          var [
            integerPart,
            decimalPart,
          ] = res_hresult.data[0].amount_total.toString().split(".");

          // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
          let decimalText = "";
          if (decimalPart) {
            decimalText =
              "จุด" +
              decimalPart
                .split("")
                .map((digit) => thaiNumbers[digit])
                .join("");
          }

          // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
          let integerText = "";
          let numArray = integerPart.split("").map(Number);
          numArray.forEach((num, index) => {
            let unit = thaiUnits[numArray.length - index - 1];
            let digit = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArray.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                integerText += "เอ็ด" + unit;
              } else if (
                num === 2 &&
                index === numArray.length - 2 &&
                numArray.length >= 2
              ) {
                integerText += "ยี่" + unit;
              } else if (
                num === 1 &&
                index === numArray.length - 2 &&
                numArray.length >= 2
              ) {
                integerText += unit;
              } else {
                integerText += digit + unit;
              }
            }
          });

          // รวมข้อความที่ได้และคืนค่ากลับ
          result = integerText + decimalText;
        }

        this.textamount_total_en = result;
      }

      this.print_header.amount_total = parseFloat(
        res_hresult.data[0].amount_total,
      );
      this.print_header.additional_top = res_hresult.data[0].additional_top;
      this.print_header.additional_bottom =
        res_hresult.data[0].additional_bottom;

    },
    async loadInvSoData() {
      var tmp_inv_data;
      const res_inv_so = await api.billing_expense_printInvSO(this.inv_id);

      tmp_inv_data = res_inv_so.data;
      if (tmp_inv_data.length > 0) {
        this.haveSO = true;
      }

      tmp_inv_data.forEach((inv_so, index) => {
        var data = {
          report_type: "SO",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
          solastdata: "",
        };
        if (index == tmp_inv_data.length - 1) {
          data.solastdata = "SOlastindex";
        }

        data.report_desc = inv_so.report_desc;
        data.report_amount = parseFloat(inv_so.report_amount);
        this.print_table_detail.push(data);
      });

      // alert("loadInvSoData")
    },
    async loadMainInvSoData() {
      var tmp_inv_data;
      const res_docref_so = await api.getRef_TypeCNById(this.inv_id);
      const res_inv_so = await api.printInvSO(res_docref_so.data[0].ref_id);

      tmp_inv_data = res_inv_so.data;

      tmp_inv_data.forEach((inv_so, index) => {
        var data = {
          report_type: "SO",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
          solastdata: "",
        };
        if (index == tmp_inv_data.length - 1) {
          data.solastdata = "SOlastindex";
        }
        // if (index == 0) {
        //   data.first_item = 1;
        // }
        data.report_desc = inv_so.report_desc;
        data.report_amount = parseFloat(inv_so.report_amount);
        this.print_table_detail.push(data);
      });
    },
    async loadInvADData() {
      var tmp_inv_data;
      // const res_docref_so = await api.getRef_TypeCNById(this.inv_id);
      // alert(this.inv_id);
      const res_docref_ad = await api.getRef_TypeADById(this.inv_id);

      if (res_docref_ad.data[0]) {
        const res_inv_mis = await api.printInvAD(res_docref_ad.data[0].ref_id);

        tmp_inv_data = res_inv_mis.data;

        tmp_inv_data.forEach((inv_mis, index) => {
          var data = {
            report_type: "AD",
            report_desc: "",
            report_amount: 0,
            first_item: 0,
          };
          if (index == 0) {
            data.first_item = 1;
          }
          data.report_desc = inv_mis.report_desc;
          data.report_amount = parseFloat(inv_mis.report_amount);
          this.print_table_detail.push(data);
        });
      }
    },
    async loadInvMISData() {
      var tmp_inv_data;
      // const res_docref_so = await api.getRef_TypeCNById(this.inv_id);
      const res_inv_mis = await api.billing_expense_printInvMIS(this.inv_id);

      tmp_inv_data = res_inv_mis.data;

      tmp_inv_data.forEach((inv_mis, index) => {
        var data = {
          report_type: "ADMIS",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
        };

        if (index == 0 && this.haveAD == false) {
          data.first_item = 1;
        }
        data.report_desc = inv_mis.report_desc;
        data.report_amount = parseFloat(inv_mis.report_amount);
        this.print_table_detail.push(data);
      });
    },
    async loadInvDocRefData() {
      const res_inv_doc_ref = await api.billing_expense_printInvDocRef(this.inv_id);
      this.indexinvADMIS = true;

      for await (const inv_doc_ref of res_inv_doc_ref.data) {
        if (inv_doc_ref.ref_type == "AD") {
          await this.loadInvAdvanceDetailData(inv_doc_ref.ref_id);
        }

        if (inv_doc_ref.ref_type == "TS") {
          await this.loadInvTimeSheetDetailData(inv_doc_ref.ref_id);
        }
      }
      // alert("loadInvDocRefData")

    },

    async loadInvTSGetTimekeeper() {

      this.datashowAlltimekeeper = [];
      if (this.print_detail_timekeeper.length <= 0) {
        return;
      }
      let data = {};

      data.hid = [this.item_id];

      const resultc = await api.billing_expense_getAllInvTSBytimesheetCreeper_hid(data);
      this.datashowAlltimekeeper = resultc.data;
      if (this.datashowAlltimekeeper.length > 0) {
        this.datashowAlltimekeeper.forEach((item) => {
          item.tc_rateChargeHour_bath = Number(item.tc_hours).toFixed(2);
          item.tc_nocharge = Math.abs(
            (
              (Number(item.tc_actualchargehour) - Number(item.tc_hours)) /
              60
            ).toFixed(2),
          );
          item.tc_nochargeCal = (
            Math.abs(
              (Number(item.tc_actualchargehour) - Number(item.tc_hours)) / 60,
            ) * Number(item.tc_rate)
          ).toFixed(2);

          //sum all
          this.sum_chargehour =
            this.sum_chargehour + Number(item.tc_actualchargehour / 60);
          this.sum_rateChargehour =
            this.sum_rateChargehour + Number(item.tc_rateChargeHour_bath);
          this.sum_noCharge_hour =
            this.sum_noCharge_hour + Number(item.tc_nocharge);
          this.sum_noCharge_bath =
            this.sum_noCharge_bath + Number(item.tc_nochargeCal);
          this.sum_grandTotal = this.sum_rateChargehour;

          item.tc_rate_show = tolocalestringnumber(item.tc_rate);

          item.tc_actualchargehour_show = tolocalestringnumber(
            Number(item.tc_actualchargehour).toFixed(2),
          );
          item.tc_rateChargeHour_bath_show = tolocalestringnumber(
            item.tc_rateChargeHour_bath,
          );
          item.tc_nocharge_show = tolocalestringnumber(item.tc_nocharge);
          item.tc_nochargeCal_show = tolocalestringnumber(item.tc_nochargeCal);
        });
      }

    },

    async checkcontent() {
      this.datashowAll = [];
      this.setdatatoshow = [];

      const linedetailprpo = 29; // จำนวนบรรทัดปกติต่อหน้า
      const datainlineprpo = 67; // ความยาวข้อความต่อบรรทัด
      const footerLines = 13; // บรรทัดที่ footer ใช้ (เฉพาะหน้าสุดท้าย)

      let getdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let checkamount_morethen_zero = false;

      for (let i = 0; i < this.print_table_detail.length; i++) {
        let row = this.print_table_detail[i];
        row.no = i + 1;

        let text = row.report_desc || "";
        let newhllinedetails = 0;

        // อักขระพิเศษที่ไม่กินพื้นที่
        const zeroWidthChars = [
          "่",
          "้",
          "๊",
          "๋",
          "ิ",
          "ี",
          "ึ",
          "ื",
          "ุ",
          "ู",
          "ั",
          "็",
        ];

        if (text.includes("\n")) {
          let dataarray = text.split("\n");
          for (let line of dataarray) {
            let len = line.length;
            for (let char of line) {
              if (zeroWidthChars.includes(char)) len--;
            }
            newhllinedetails += Math.ceil(len / datainlineprpo);
          }
          hllinedetails += dataarray.length - 1; // นับ newline เป็นบรรทัดเพิ่ม
        } else {
          let len = text.length;
          for (let char of text) {
            if (zeroWidthChars.includes(char)) len--;
          }
          newhllinedetails = Math.ceil(len / datainlineprpo);
        }

        // เพิ่มบรรทัดกรณีเงื่อนไขพิเศษ
        if (
          row.first_item == 1 ||
          row.solastdata == "SOlastindex" ||
          this.haveSO == false
        ) {
          newhllinedetails += 2;
        }

        if (
          i > 0 &&
          row.report_amount > 0 &&
          !checkamount_morethen_zero &&
          this.print_table_detail[i - 1].report_amount == 0
        ) {
          row.amount_morethen_zero = "yes";
          newhllinedetails += 1;
          checkamount_morethen_zero = true;
        }

        // ตรวจว่ารายการนี้เป็นรายการสุดท้ายหรือไม่
        const isLastItem = i === this.print_table_detail.length - 1;

        // ถ้ารายการสุดท้าย → ลดจำนวนบรรทัดในหน้าสุดท้ายเพื่อเผื่อ footer
        let currentPageLineLimit = linedetailprpo;
        if (isLastItem) {
          currentPageLineLimit -= footerLines;
        }

        // ถ้าเกินบรรทัดหน้าปัจจุบัน → สร้างหน้าใหม่
        if (hllinedetails + newhllinedetails > currentPageLineLimit) {
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;
          hllinedetails = 0;
          getdata = [];
        }

        // ใส่ข้อมูลในหน้าปัจจุบัน
        getdata.push(row);
        hllinedetails += newhllinedetails;

        // ถ้ารายการสุดท้าย → เก็บหน้าสุดท้ายไว้
        if (isLastItem) {
          this.setdatatoshow[this.pageAll - 1] = getdata;
        }
      }

      this.opensummarize = true;

      // ทำเครื่องหมาย lastdata ในแถวสุดท้ายของหน้าสุดท้าย
      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem === this.setdatatoshow.length - 1) {
          item[item.length - 1].lastdata = "lastindex";
        }
        this.datashowAll.push(item);
      });
    },

    async checkcontenttimesheet() {
      this.datashowAlltimesheet = [];
      // alert(data.length);
      this.setdatatoshowtimesheet = [];
      let linedetailprpo = 42;
      let datainlineprpo = 60;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAlltimesheet = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_detailtimesheet.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_detailtimesheet[i]
          .report_desc.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_detailtimesheet[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_detailtimesheet[i].report_desc.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // newhllinedetails = Math.ceil(
        //   this.print_table_detailtimesheet[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.print_table_detailtimesheet[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
          this.pageAlltimesheet++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_detailtimesheet[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_detailtimesheet.length - 1) {
            this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_detailtimesheet[i]);

          if (i == this.print_table_detailtimesheet.length - 1) {
            this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarizetimesheet = true;

      this.setdatatoshowtimesheet.forEach((item, iitem) => {
        if (iitem == this.setdatatoshowtimesheet.length - 1) {
          item[this.setdatatoshowtimesheet[iitem].length - 1].lastdata =
            "lastindex";
        }

        this.datashowAlltimesheet.push(item);
      });
    },

    async loadInvTimeSheetDetailData(ref_id) {
      var tmp_inv_data;
      this.print_detail_timekeeper.push(ref_id);
      const res_inv_time_sheet_detail = await api.billing_expense_printInvTS(ref_id);

      tmp_inv_data = res_inv_time_sheet_detail.data;

      tmp_inv_data.forEach((inv_time_sheet_detail) => {
        var data = {
          report_type: "TS",
          report_desc: "",
          report_amount: 0,
          report_date: "",
          lawyer: "",
        };

        data.report_desc = inv_time_sheet_detail.report_desc;
        data.report_amount = parseFloat(inv_time_sheet_detail.report_amount);
        data.report_date = inv_time_sheet_detail.report_date;
        data.lawyer = inv_time_sheet_detail.lawyer;
        this.print_table_detailtimesheet.push(data);
      });
    },
    async loadInvAdvanceDetailData(ref_id) {
      var tmp_inv_data;
      const res_inv_advance_detail = await api.billing_expense_printInvAD(ref_id);
      // //console.log(res_inv_advance_detail.data)
      tmp_inv_data = res_inv_advance_detail.data;
      if (tmp_inv_data.length > 0) {
        this.haveAD = true;
      }

      tmp_inv_data.forEach((inv_advance_detail, index) => {
        var data = {
          report_type: "ADMIS",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
        };
        if (this.indexinvADMIS == true && index == 0) {
          data.first_item = 1;
        }

        data.report_desc = inv_advance_detail.report_desc;
        data.report_amount = parseFloat(inv_advance_detail.report_amount);
        this.print_table_detail.push(data);
      });
      this.indexinvADMIS = false;
    },

    editItem() { },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    formatDate(date) {
      // //console.log(`formatDate header:${JSON.stringify(this.header)}`);
      // //console.log(`formatDate date:${date.toISOString().substr(0, 10)}`);

      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },
    // finddatafromdate() {
    //   //alert(this.datefrom)
    //   this.mDataArray = this.dataAll.filter((item) => {
    //     if (this.search_status == "") {
    //       if (this.datefrom != null && this.dateto != null) {
    //         if (item.date >= this.datefrom && item.date <= this.dateto) {
    //           return item;
    //         }
    //       }
    //       if (this.datefrom == null && this.dateto == null) {
    //         return item;
    //       }
    //     } else {
    //       if (this.datefrom != null && this.dateto != null) {
    //         if (
    //           item.date >= this.datefrom &&
    //           item.date <= this.dateto &&
    //           item.status == this.search_status
    //         ) {
    //           return item;
    //         }
    //       }
    //       if (this.datefrom == null && this.dateto == null) {
    //         if (item.status == this.search_status) {
    //           return item;
    //         }
    //       }
    //     }
    //   });
    // },
    findChaege() {
      let data_s = [];
      data_s = this.dataAll2;

      if (this.company_search != "") {
        // alert("com")
        data_s = data_s.filter((item) => {
          if (item.company_inv == this.company_search) {
            return item;
          }
        });
      }
      if (this.department_search != 0) {
        // alert("dept")
        data_s = data_s.filter((item) => {
          if (item.dept_inv == this.department_search) {
            return item;
          }
        });
      }
      if (this.search_status != "") {
        // alert("status")
        data_s = data_s.filter((item) => {
          if (item.status == this.search_status) {
            return item;
          }
        });
      }

      if (this.datefrom != null && this.dateto != null) {
        // alert("date")
        data_s = data_s.filter((item) => {
          if (item.date >= this.datefrom && item.date <= this.dateto) {
            return item;
          }
        });
      }

      // //console.log(`search: ${this.search}`);

      // เพิ่มการค้นหาด้วย search text
      if (this.search != "" && this.search != null) {
        data_s = data_s.filter((item) => {
          const searchTerm = this.search.toLowerCase();
          return (
            (item.invoice_no &&
              item.invoice_no.toLowerCase().includes(searchTerm)) ||
            (item.customer_name &&
              item.customer_name.toLowerCase().includes(searchTerm)) ||
            (item.customer_cust_account &&
              item.customer_cust_account.toLowerCase().includes(searchTerm)) ||
            (item.inv_id && item.inv_id.toLowerCase().includes(searchTerm)) ||
            (item.pinv_id && item.pinv_id.toLowerCase().includes(searchTerm))
          );
        });
        // //console.log(`filtered by search: ${data_s.length}`); // Debug log
        // //console.log(`data_s: ${JSON.stringify(data_s)}`); // Debug log
      }

      if (
        this.company_search == "" &&
        this.department_search == 0 &&
        this.search_status == "" &&
        this.datefrom == null &&
        this.dateto == null &&
        (this.search == "" || this.search == null)
      ) {
        data_s = this.dataAll2;
      }
      // //console.log(`data_s22: ${JSON.stringify(data_s)}`); // Debug log
      this.mDataArray2 = data_s;
    },
    onClicktonewinvoice(id) {
      let name = "inv_h";
      this.$router.push(`/edit-invoice/${id}/${name}/edit`);
    },
    async loaddataInvoice() {
      const result = await api.getdataInvoice_HBycompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          department_id: localStorage.getItem(server.DEPARTMENT_ID),
        },
      });
      this.dataAll = result.data;

      this.mDataArray = result.data;
      this.mDataArray.forEach((item) => {
        if (item.inv_id) {
          item.invoice_no = item.inv_id;
        } else if (item.pinv_id) {
          item.invoice_no = item.pinv_id;
        } else {
          item.invoice_no = "####";
        }
        item.amount_show = tolocalestringnumber(item.inv_amount);
      });

      // this.$showLoader();
      this.$hideLoader();
    },
  },
};
</script>

<style scoped>
.v-btn:hover {
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

.v-radio:hover {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 4px;
}

/* เปลี่ยนสี radio button เป็นสีดำตอน select */
::v-deep .v-radio .v-icon {
  color: #000000 !important;
}

::v-deep .v-radio--is-active .v-icon {
  color: #000000 !important;
}
</style>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "Roboto", sans-serif;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred100 {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captiontotal {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.8rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.8;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-20prpo {
  margin-top: -20px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.ml-40prpo {
  margin-left: -40px !important;
}

.borderblockpr {
  border: 1px solid black;
  width: 300px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

.textaligncenter {
  text-align: center;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}

td.tdborder-top {
  border-top: 1px solid black;
}

td.tdborder-right {
  border-right: 1px solid black;
}

td.tdborder-left {
  border-left: 1px solid black;
}

td.tdborder-bottom {
  border-bottom: 1px solid black;
}

th {
  /* border: 1px solid black; */
}

th.thborder-top {
  border-top: 1px solid black;
}

th.thborder-right {
  border-right: 1px solid black;
}

th.thborder-left {
  border-left: 1px solid black;
}

th.thborder-bottom {
  border-bottom: 1px solid black;
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width98 {
  word-wrap: break-word;
  width: 98%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
          body.A3.landscape { width: 420mm }
          body.A3, body.A4.landscape { width: 297mm }
          body.A4, body.A5.landscape { width: 210mm }
          body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}

.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}

.fixthreerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fixonerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}

.fontsize10 {
  font-size: 10px;
}

.fontsize12 {
  font-size: 12px;
}

.fontsize13 {
  font-size: 13px;
}

.fontsize14 {
  font-size: 14px;
}

.borderwidththin {
  border-width: thin;
  border-color: darkgray;
}

.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}

.paddingleftintable {
  padding-left: 10px;
}

.paddingrightintable {
  padding-right: 10px;
}

.v-text-field.v-text-field--enclosed .v-text-field__details .cutdetailtextfield {
  padding-top: 0px;
  margin-bottom: -25px;
}

.v-application a {
  color: white;
}

.containertab {
  max-width: 100%;
  min-width: 100%;
  margin: 40px auto;
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 0.9em;
  color: #888;
}

.tabs {
  overflow: hidden;
  /* margin-left: 20px; */
  margin-bottom: -2px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 10px 24px;
  transition: background-color 0.2s;
  border: 1px solid #595959;
  /* border-right: none; */
  border-right: 1px solid #595959;
  background-color: #595959;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
}

/* .tabs a:last-child {
  border-right: 1px solid #595959;
} */

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #aaa;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #484848;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  border: 1px solid #595959;
  /* border-radius: 10px; */
  border-radius: 0px 10px 10px 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
}

.btn-width {
  width: 120px;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.width16 {
  width: 16%;
}

.widthsubtotal {
  width: 18%;
}

.widthplus {
  width: 4%;
}

.widthsub {
  width: 6%;
}

.widthgrandnull {
  width: 51%;
}

.widthspace {
  width: 1%;
}

.widthglessword {
  width: 30%;
}

.widthlesspersen {
  width: 6%;
}

.widthtextpersen {
  width: 4%;
}

.widthlesstotal {
  width: 8%;
}

.wordspacingsummary {
  /* word-spacing: -1px; */
  letter-spacing: 1px;
}

.fontweight700 {
  font-weight: 700;
}

.col-md-6report55 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 55%;
  flex: 0 0 55%;
  max-width: 55%;
}

.col-md-6report45 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 45%;
  flex: 0 0 45%;
  max-width: 45%;
}

.col-md-2report20 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}

.col-md-10report80 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 80%;
  flex: 0 0 80%;
  max-width: 80%;
}

.col-md-3report27 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 27%;
  flex: 0 0 27%;
  max-width: 27%;
}

.col-md-9report73 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 73%;
  flex: 0 0 73%;
  max-width: 73%;
}

.doubleunderline {
  /* text-decoration-line: underline;
  text-decoration-style: double; */
  border-bottom: 3px double #000000;
  border-top: 1px double #000000;
  /* text-underline-offset: 4px; */
  /* padding-bottom:4px;
  height: 1px; */
}
</style>
